import axios from 'axios';

export default () => {
    const mainMapSearch = document.querySelectorAll('.my-map--init')
    if (!mainMapSearch) {
        return;
    }

    let blueColorMap = "#a2b7ce";

    let stylesMap = [
        {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#000"
                }
            ]
        },
        {
            "featureType": "administrative.country",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "administrative.province",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "hue": "#ff0000"
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#EBEBEB"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": 45
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "color": blueColorMap
                },
                {
                    "visibility": "on"
                }
            ]
        }
    ];

    mainMapSearch.forEach(n => {
        if (!mapJson) {
            return;
        }
        let markersOnMap = Object.values(mapJson);
        console.log(markersOnMap);
        initMap();

        function initMap() {

            let InforObj = [];
            let centerCords;
            let zoomMap;

            centerCords = new google.maps.LatLng(markersOnMap[0].centerCoord[0].placeLat, markersOnMap[0].centerCoord[0].placeLng),
                zoomMap = markersOnMap[0].centerCoord[0].zoomMapDefault;

            let options = {
                zoom: zoomMap,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                center: centerCords,
                zoomControl: false,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.LEFT_BOTTOM
                },
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                styles: stylesMap
            };

            let myMap = new google.maps.Map(n, options);

            function defaultDot() {
                let Long = (screen.width <= 639 )? markersOnMap[0].centerCoord[0].placeLng  + 0.0020: markersOnMap[0].centerCoord[0].placeLng;
                let myLatlng = new google.maps.LatLng(markersOnMap[0].centerCoord[0].placeLat , Long);
                let marker = new google.maps.Marker({
                    position: myLatlng,
                    map: myMap,
                    icon: {
                        url: markersOnMap[0].centerCoord[0].img,
                        origin: new google.maps.Point(0, 0),
                        // anchor: (screen.width <= 639 )? new google.maps.Point(28, 22) :new google.maps.Point(45, 22),
                        anchor: new google.maps.Point(45, 22),
                    }
                });
                myMap.setCenter(myLatlng);
                if (window.innerWidth <= 639) {
                    marker.icon.scaledSize = new google.maps.Size(45, 40);
                }
            }

            defaultDot();

            let data1 = new google.maps.Data();

            function setBicycleRoute(map) {
                data1.loadGeoJson(urlBikeMap, {},
                    function (features) {

                    }
                );
                data1.setStyle({
                    strokeColor: '#747474',
                });

                myMap.setZoom(14);
                myMap.setCenter(centerCords);
                data1.setMap(map);
            }

            let markers = [];

            function setAfoot(map) {
                let latlngbounds = new google.maps.LatLngBounds();

                let circleArray = markersOnMap[1].afoot

                n.classList.remove('my-map--infowindow-second')
                // n.classList.remove('my-map--infowindow-three')
                n.classList.remove('my-map--infowindow-three')
                n.classList.add('my-map--infowindow-four')

                for (let i = 0; i < circleArray.length; i++) {
                    let myLatlngSet2 = new google.maps.LatLng(circleArray[i].circlePlaceLat, circleArray[i].circlePlaceLng);
                    let myLatlngSetIcon2 = new google.maps.LatLng(circleArray[i].iconPlaceLat, circleArray[i].iconPlaceLng);

                    const cityCircle = new google.maps.Circle({
                        strokeColor: "#000",
                        strokeOpacity: 0.8,
                        strokeWeight: 1,
                        fillColor: "transparent",
                        // fillOpacity: 0.35,
                        map: map,
                        center: myLatlngSet2,
                        radius: circleArray[i].radius,
                    });

                    let marker = new google.maps.Marker({
                        position: myLatlngSetIcon2,
                        map: map,
                        icon: {
                            url: circleArray[i].img,
                            anchor: new google.maps.Point(11, 18),
                        },
                    });
                    
                    let infowindow = new google.maps.InfoWindow({
                        disableAutoPan: true,
                        content: `<div class="my-inf ${circleArray[i].classRight}">
                                    <div class="my-inf__name">${circleArray[i].name}</div>
                                </div>`,
                        pixelOffset: new google.maps.Size(circleArray[i].positionNameX, circleArray[i].positionNameY),
                        minWidth: 220,
                    });
                    infowindow.open(myMap, marker);

                    markers.push(marker);
                    markers.push(cityCircle);


                    latlngbounds.extend(marker.position);
                }
                myMap.setCenter(centerCords);
                myMap.setZoom(16);
            }

            setAfoot(myMap);

            function setAuto() {
                let latlngbounds = new google.maps.LatLngBounds();

                let autoArray = markersOnMap[2].auto

                n.classList.remove('my-map--infowindow-second')
                n.classList.add('my-map--infowindow-three')
                n.classList.remove('my-map--infowindow-four')
   
                for (let i = 0; i < autoArray.length; i++) {
                    let name = (autoArray[i].name).toLowerCase().replace(/\s/g, "");
                    let myLatlngSetIcon3 = new google.maps.LatLng(autoArray[i].iconPlaceLat, autoArray[i].iconPlaceLng);
                    let infowindow = new google.maps.InfoWindow({
                        disableAutoPan: true,
                        content: `<div class="my-inf ${autoArray[i].classRight}">
                                    <div class="my-inf__name" data-name="${name}" >${autoArray[i].name}</div>
                                </div>`,
                        pixelOffset: new google.maps.Size(autoArray[i].positionNameX, autoArray[i].positionNameY),
                    });

                    let markerOptions = {
                        position: myLatlngSetIcon3,
                        map: myMap,
                        icon: {
                            url: autoArray[i].img,
                            size: new google.maps.Size(48, 40),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(45, 22),
                        },
                    }
                    if (window.innerWidth <= 639) {
                        markerOptions.icon.scaledSize = new google.maps.Size(32, 32);
                    }


                    let markerSet3 = new google.maps.Marker(markerOptions);
                    infowindow.open(myMap, markerSet3);
                    markers.push(markerSet3);


                    latlngbounds.extend(markerSet3.position);
                    myMap.setCenter(latlngbounds.getCenter());
                    myMap.fitBounds(latlngbounds);
                }

            }
            setAuto();
            function setRailway() {
                let latlngbounds = new google.maps.LatLngBounds();

                let railwayArray = markersOnMap[3].railway

                n.classList.remove('my-map--infowindow-second')
                n.classList.remove('my-map--infowindow-three')
                n.classList.remove('my-map--infowindow-four')

                for (let i = 0; i < railwayArray.length; i++) {

                    let infowindow = new google.maps.InfoWindow({
                        disableAutoPan: true,
                        content: `<div class="my-inf rail ${railwayArray[i].classPushTop} ${railwayArray[i].classRight}">
                                    <div class="my-inf__name">${railwayArray[i].name}</div>
                                    <div class="my-inf__time">${railwayArray[i].time}</div>
                                    <div class="my-inf__img ${railwayArray[i].imgInnerClass}">
                                        <img src="${railwayArray[i].imgInner}" alt="img">
                                    </div>
                                </div>`,
                        pixelOffset: new google.maps.Size(railwayArray[i].positionNameX, railwayArray[i].positionNameY),
                    });

                    let myLatlngSetIcon4 = new google.maps.LatLng(railwayArray[i].iconPlaceLat, railwayArray[i].iconPlaceLng);

                    let markerOptions = {
                        position: myLatlngSetIcon4,
                        map: myMap,
                        icon: {
                            url: railwayArray[i].img,
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(22, 22),
                        }
                    }
                    if (window.innerWidth <= 639) {
                        markerOptions.icon.scaledSize = new google.maps.Size(20, 20);
                    }

                    let markerSet4 = new google.maps.Marker(markerOptions);

                    infowindow.open(myMap, markerSet4);
                    markers.push(markerSet4);

                    latlngbounds.extend(markerSet4.position);
                }

                myMap.fitBounds(latlngbounds);
            }

            function setAero() {
                let latlngbounds = new google.maps.LatLngBounds();

                let aerodromeArray = markersOnMap[4].aerodrome

                n.classList.add('my-map--infowindow-second')
                n.classList.remove('my-map--infowindow-three')
                n.classList.remove('my-map--infowindow-four')

                for (let i = 0; i < aerodromeArray.length; i++) {
                    let infowindow = new google.maps.InfoWindow({
                        disableAutoPan: true,
                        content: `<div class="my-inf my-inf_aero">
                                    <div class="my-inf__img-arrow">
                                        <img src="${aerodromeArray[i].imgArrow}" alt="img">
                                    </div>
                                    <div class="my-inf__name">${aerodromeArray[i].name}</div>
                                    <div class="my-inf__time">${aerodromeArray[i].time}</div>
                                </div>`
                    });

                    let myLatlngSetIcon5 = new google.maps.LatLng(aerodromeArray[i].iconPlaceLat, aerodromeArray[i].iconPlaceLng);

                    let markerOptions = {
                        position: myLatlngSetIcon5,
                        map: myMap,
                        icon: {
                            url: aerodromeArray[i].img,
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(14, 14),
                        }
                    }
                    if (window.innerWidth <= 639) {
                        markerOptions.icon.scaledSize = new google.maps.Size(18, 18);
                    }

                    let markerSet5 = new google.maps.Marker(markerOptions);
                    markers.push(markerSet5);
                    infowindow.open(myMap, markerSet5);
                    latlngbounds.extend(myLatlngSetIcon5);
                }

                myMap.fitBounds(latlngbounds, 16);
            }

            function setMapOnAll(myMap) {
                for (let i = 0; i < markers.length; i++) {
                    markers[i].setMap(myMap);
                }
            }

            function resetMapRoutes() {
                setBicycleRoute(null);
                setAfoot(null);
                setMapOnAll(null)                
                let cycleLabel =  document.getElementById('cycle-label');
                cycleLabel.classList.add('hide-cycle-label');            
            }

            function setMapRouteEvetns() {
                let mapBtns = document.querySelectorAll('.main-map__nav-item');
                mapBtns.forEach((button) => {
                    button.addEventListener('click', function (e) {
                        let isActiveBtn = this.classList.contains('_active');
                        // if (isActiveBtn) return;

                        resetMapRoutes();

                        let mapRouteAttr = this.getAttribute('data-map-route');

                        if (mapRouteAttr === 'bicycle') {
                            setBicycleRoute(myMap);
                            // data1.setMap(null)
                            let cycleLabel =  document.getElementById('cycle-label');
                            cycleLabel.classList.remove('hide-cycle-label');
                        }
                        if (mapRouteAttr === 'afoot') {
                            setAfoot(myMap);
                        }
                        if (mapRouteAttr === 'set2') {
                            setAfoot(myMap);
                            setAuto();
                        }
                        if (mapRouteAttr === 'automobile') {
                            setAfoot(myMap);
                            setAuto();
                        }
                        if (mapRouteAttr === 'railway') {
                            setRailway();
                        }
                        if (mapRouteAttr === 'aerodrome') {
                            setAero();
                        }

                        for (let btn of mapBtns) {
                            btn.classList.remove('_active');
                        }

                        this.classList.add('_active');
                    })
                })
            }

            setMapRouteEvetns();
        };
    });
}
